module.exports = __webpack_public_path__ + "static/img/第十二届.f6aabb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/20260620/past/第十二届.png
// module id = Ije0
// module chunks = 1